import Image from 'next/image';
import React from 'react';

//this is a dead simple component to tweak the props of next/image component before passing it as ImageComponentProp
export default function CustomImage(props) {
  return <Image priority alt={'Image'} {...props} quality={50} w={500} sizes={'21rem'} />;
}
